const actionTypes = {
  SET_OPTION: 'SET_OPTION'
}

export default actionTypes
